<template>
	<div>

		<!--  轮播  -->
		<div style="width:100%;border-bottom: 1px solid #efefef;box-shadow: 0px 0px .6rem #ccc;">
			<slider ref="slider" :options="options">
				<slideritem v-for="(item,index) in sliderList" :key="index">
					<img style="width:100%;border-radius: 0.5rem;" :src="item.image" @click="clickSlider(item)">
				</slideritem>
				<div slot="loading">loading...</div>
			</slider>
		</div>
		<!--  轮播  -->

		<!-- 分类: 新品 -->
		<div class="new">
			<div style="margin: .5rem auto;width: 90%;">
				<span style="font-size: 0.6rem;">AI训练/OpenClaw</span>
				<span style="float: right;">-</span>
			</div>
			<div class="index-goods" v-for="(item,index) in goodsInfo.figure" :key="index">
				<img class="index-image" :src="item.goods_image" @click="pageTo('/goods?gid=' + item.goods_id )"/>
				<div class="index-name">{{item.goods_name}}</div>
				<div class="index-price">￥{{item.goods_price}}</div>
			</div> 
		</div>

		<!-- 分类: 新品 -->
		<div class="new">
			<div style="margin: .5rem auto;width: 90%;">
				<span style="font-size: 0.6rem;">手机/游戏</span>
				<span style="float: right;">-</span>
			</div>
			<div class="index-goods" v-for="(item,index) in goodsInfo.game" :key="index">
				<img class="index-image" :src="item.goods_image" @click="pageTo('/goods?gid=' + item.goods_id )" />
				<div class="index-name">{{item.goods_name}}</div>
				<div class="index-price">￥{{item.goods_price}}</div>
			</div> 
		</div>

		<!-- 分类: 新品 -->
		<div class="new">
			<div style="margin: .5rem auto;width: 90%;">
				<span style="font-size: 0.6rem;">手办/其他</span>
				<span style="float: right;">-</span>
			</div>
			<div class="index-goods" v-for="(item,index) in goodsInfo.other" :key="index">
				<img class="index-image" :src="item.goods_image" @click="pageTo('/goods?gid=' + item.goods_id )" />
				<div class="index-name">{{item.goods_name}}</div>
				<div class="index-price">￥{{item.goods_price}}</div>
			</div> 
		</div>

		<!-- 分类: 预售 -->
		<div class="pre"></div>


		<!-- 组件使用 -->
		<syalert ref="syalert_id" />

		<!-- 组件使用 -->
		<foot />

	</div>
</template>
<style>
	.new
	{
		/* width: 90%; */
		margin: .5rem auto;
		margin-left: 0.1rem;
		clear: both;
	}
	.hot
	{
		clear: both;
	}
	
	.index-goods
	{
		float: left;
		margin: .5rem auto;
		margin-left: 0.8rem;
	}
	.index-image
	{
		width: 9rem;
		border-radius: 0.5rem;
	}
	.index-name
	{
		width: 9rem;
		font-size: .8rem; 
		/* 多行溢出控制 */
		display: -webkit-box;
		-webkit-line-clamp: 2; /* 限制显示的行数为3行 */
		-webkit-box-orient: vertical;
		overflow: hidden; /* 隐藏溢出的内容 */
		
		/* 单行溢出控制 */
		/* white-space: nowrap; */ /* 防止文本换行 */
		/* overflow: hidden; */ /* 隐藏溢出的内容 */
		/* text-overflow: ellipsis; */ /* 使用省略号表示溢出的文本 */
	}
	.index-price
	{
		font-size: .8rem;
	}

</style>
<script>

	import sy from "@/sy";
	
	// ---------- 引入组件
	import foot from '@/components/foot.vue';
	import syalert from '@/components/syalert.vue';

	// ---------- 引入轮播
	import {
		slider,
		slideritem
	} from 'vue-concise-slider';

	// 如果文件放在 assets 目录下，需如此引用
	// import img1 from "@/assets/image/banner1.jpg";
	// import img2 from "@/assets/image/banner2.jpg";
	// import img3 from "@/assets/image/banner3.jpg";
	// import img4 from "@/assets/image/banner4.jpg";
 
	// 如果放置在 public 目录下，直接引用即可

	export default {
		name: 'index',
		components: {
			slider,
			slideritem,
			foot,
			syalert,
		},
		data() {
			return {
  
				goodsInfo:[],

				// ---- ---- 轮播参数
				options: {
					currentPage: 0,
					speed: 300,
					itemAnimation: true,
					centeredSlides: true,
					thresholdDistance: 100,
					thresholdTime: 300,
					autoplay: 3000,
					loopedSlides: 2,
					slidesToScroll: 1,
					loop: true
				},
				sliderList: [
					{
						title: '',
						image: 'images/banner5.jpg',
						type: 1,
						value: '/goods?gid=3',
					},
					{
						title: '',
						image: 'images/banner6.png',
						type: 1,
						value: '/goods?gid=4',
					},
				],
			}
		},
		methods: {
			pageTo: function(page) {
				if (page !== undefined) {
					this.$router.push(page);
				} else {
					this.$router.go(-1);
				}
			},
			gotoPage: function(page)
			{
				if (page !== undefined) {
					this.$router.push(page);
				} else {
					this.$router.go(-1);
				}
			},

			// ----- ----- 点击轮播功能
			clickSlider: function(obj)
			{
				if (obj.type == 0) {
					console.log('轮播0');
					return false;
				}
				// 跳转网页
				if (obj.type == 1) {
					location.href = obj.value;
				}
				// 跳转内部
				if (obj.type == 2) {
					this.pageTo(obj.value);
				}
			},

			// ----- ----- 获取首页数据
			check: function()
			{
				// 实例重命名
				let $_this = this;
				sy.http.get(
				{
					url: this.$root.API + 'Index/Get',
					data: {
						page: '0',
					},
					success: function(res)
					{
						if (res.state == '1')
						{
							$_this.goodsInfo = res.data;
						}
					}
				});

			}
		},
		created(){
			this.check();
		}


	}
</script>